import type { ILocaleType } from "@configs";

export function isDigit(str: string): boolean {
  return str === "" || /^\d*$/.test(str);
}

export function persianToEnglishNumber(
  input: string,
  locale: ILocaleType,
): string {
  if (locale === "fa") return input;
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

  return input.replaceAll(/[۰-۹]/g, (digit) =>
    persianDigits.indexOf(digit).toString(),
  );
}
